import React, { ComponentPropsWithRef, FC } from 'react';
import classnames from 'classnames';

import './PlcList.scss';

type Props = ComponentPropsWithRef<'ul'>;

const PlcList: FC<Props> = ({ className, ...rest }) => {
  const rootClass = classnames('plc-list', 'flex', 'wrap', className);
  return <ul className={rootClass} {...rest} />;
};

export { PlcList };
